import { useState } from "react";

export default function IngredientListGrouped({ recipes }) {
  const [filter, setFilter] = useState("all");
  const [checked, setChecked] = useState(() => {
    const init = {};
    recipes.forEach((r) =>
      r.ingredients.forEach((_, i) => {
        init[`${r._id}-${i}`] = false;
      })
    );
    return init;
  });

  const toggle = (key) => {
    setChecked((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  return (
    <div className="space-y-6 pb-4">
      {/* Filters */}
      <div className="flex flex-wrap gap-2">
        <button
          onClick={() => setFilter("all")}
          className={`text-sm px-3 py-1 rounded ${
            filter === "all" ? "bg-blue-500 text-white" : "bg-gray-100 text-gray-700"
          }`}
        >
          All Recipes
        </button>
        {recipes.map((r) => (
          <button
            key={r._id}
            onClick={() => setFilter(r._id)}
            className={`text-sm px-3 py-1 rounded ${
              filter === r._id ? "bg-blue-500 text-white" : "bg-gray-100 text-gray-700"
            }`}
          >
            {r.name}
          </button>
        ))}
      </div>

      {/* Ingredients */}
      {recipes
        .filter((r) => filter === "all" || r._id === filter)
        .map((recipe) => (
          <div key={recipe._id} className="space-y-2">
            <h2 className="text-lg font-semibold border-b pb-1">{recipe.name}</h2>
            <ul className="pl-4 space-y-1">
              {recipe.ingredients.map((item, i) =>
                item.isHeading ? (
                  <li key={i} className="font-semibold mt-4">{item.text}</li>
                ) : (
                  <li key={i}>
                    <label className="flex items-center gap-2">
                      <input
                        type="checkbox"
                        checked={checked[i]}
                        onChange={() => toggle(i)}
                      />
                      <span
                        className={checked[i] ? "line-through text-gray-500" : ""}
                      >
                        {/*if item.quantity then show this too */}
                        {item.quantity && item.quantity !== "" && (
                          item.quantity+" "
                        )}
                        {item.text}
                      </span>
                    </label>
                  </li>
                )
              )}
            </ul>
          </div>
        ))}
    </div>
  );
}
